import { MagnifyingGlass, X } from "@phosphor-icons/react";
import { m } from "@plannello/i18n/messages";
import {
  SearchField as AriaSearchField,
  type SearchFieldProps as AriaSearchFieldProps,
  Button,
  Input,
} from "react-aria-components";
import { cx } from "@/lib/cx";
import { controlHeight, inputBase } from "./field";

export interface SearchFieldProps extends Omit<AriaSearchFieldProps, "className" | "children" | "aria-label"> {
  /** Accessible name; the field has no visible label, the placeholder says what it searches. */
  label: string;
  placeholder?: string;
  className?: string;
}

/** Filter box for tables and lists: magnifier, clear button, Escape clears. Controlled via `value`. */
export function SearchField({ label, placeholder, className, ...props }: SearchFieldProps) {
  return (
    <AriaSearchField
      aria-label={label}
      className={cx("group relative flex min-w-0 items-center", className)}
      {...props}
    >
      <MagnifyingGlass size={14} aria-hidden="true" className="pointer-events-none absolute left-2.5 text-fg-subtle" />
      <Input
        placeholder={placeholder}
        className={cx(inputBase, controlHeight, "pr-8 pl-8 [&::-webkit-search-cancel-button]:hidden")}
      />
      <Button
        aria-label={m.ui_clear_search()}
        className="absolute right-0.5 inline-flex size-(--control-h-sm) items-center justify-center rounded-control text-fg-muted group-data-empty:hidden data-hovered:bg-hover data-hovered:text-fg data-pressed:bg-active"
      >
        <X size={12} aria-hidden="true" />
      </Button>
    </AriaSearchField>
  );
}
